import { useLanguage } from '@/hooks/useLanguage';

export default function LogDashboardPage() {
  const { t } = useLanguage();
  return <div style={{ padding: '48px' }}><h1>{t('admin.logsComingSoon')}</h1></div>;
}
